import "./css/app.css";

import { FullScreen, useFullScreenHandle } from 'react-full-screen';

import { useTranslation } from "react-i18next";

import { useState, lazy, Suspense } from "react";

import { backendApi } from "@/utils/URL";

const Login = lazy(() => import('/src/pages/Login'));
const Recover = lazy(() => import('/src/pages/Password/Recover'));
const Dashboard = lazy(() => import('/src/pages/Dashboard'));

import { getToken, saveToken, removeToken } from '@/utils/Token';
//const getToken = await import('/src/utils/Token').then(lib => lib.getToken)
//const saveToken = await import('/src/utils/Token').then(lib => lib.saveToken)
//const removeToken = await import('/src/utils/Token').then(lib => lib.removeToken)

import { getUser, saveUser, removeUser } from '@/utils/User';

const LanguageModal = lazy(() => import('/src/modals/LanguageModal'));

//import Toast from "@/components/Toast";
const Toast = lazy(() => import('/src/components/Toast'));

import { checkIfForgot } from '@/utils/Table';

function App({handleLanguage}) {

    const { t, i18n } = useTranslation('global');

    // to get fullscreen on the browser
    const fullScreen = useFullScreenHandle();
  
    const apiUrl = backendApi();

    const [ token, setToken ] = useState(getToken());
    const [ user, setUser ] = useState(getUser());

    // check if recovering password
    const [ isForgot, setIsForgot ] = useState(checkIfForgot());
    
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastError, setToastError] = useState('');

    const handleLogin = (token = null,user = null,logout = false) => {

        if(token && user){
            setToken(token); // save on variable
            saveToken(token); // save on storage
            saveUser(user); // save on storage
            setUser(user); // save on variable
        }
        else{
            setToken(null);
            removeToken();
            removeUser();
            setUser(null);
            setIsForgot(false);
            
            if(!logout){
                sendMessage(t('error.unauthorized'),'error');
            }
        }
    }

    const sendMessage = (message, type = 'success') => {

        if(type === 'success'){
            setToastMessage(message);
            setToastError('');
        }
        else{
            setToastMessage('');
            setToastError(message);
        }
        
        setToastOpen(true);
    }

    // to go to top when scrolling
    /*
    does not work. it is always false
    const scrollTrigger = useScrollTrigger({
        //target: containerRef.current || window,
        disableHysteresis: true,
        threshold: 100,
    });
    */

    // to change the language
    const [ showLanguage, setShowLanguage ] = useState(false);
    
    const handleChangeLanguage = (iso) => {  

        // close language modal
        setShowLanguage(false);

        // call parent method for hot change
        handleLanguage(iso);
    };

    return (
        <FullScreen handle={fullScreen}>
        {
            toastOpen &&
            <Suspense>
                <Toast 
                    open={toastOpen} 
                    setOpen={setToastOpen}
                    message={toastMessage}
                    error={toastError}
                />
            </Suspense>
        }
        {
            showLanguage &&
            <Suspense>
                <LanguageModal 
                    t={t}
                    open={showLanguage} 
                    setOpen={setShowLanguage} 
                    language={i18n.language}
                    handleLanguage={handleChangeLanguage}
                    fullScreen={fullScreen}
                />
            </Suspense>
        }
        
        {
            token && token.length > 0 ?
                <Suspense>
                    <Dashboard 
                        t={t}
                        i18n={i18n}
                        apiUrl={apiUrl} 
                        handleLogin={handleLogin}
                        token={token}
                        user={user}
                        setUser={setUser}
                        setToken={setToken}
                        sendMessage={sendMessage}  
                        setShowLanguage={setShowLanguage}
                        fullScreen={fullScreen}                      
                    />
                </Suspense>
            :                
                isForgot ? 
                        
                    <Recover
                        t={t}
                        language={i18n.language}
                        apiUrl={apiUrl}
                        sendMessage={sendMessage}
                        setIsForgot={setIsForgot}
                        setShowLanguage={setShowLanguage}  
                    />                    
                :                    
                    <Login
                        t={t} 
                        language={i18n.language}
                        apiUrl={apiUrl}
                        handleLogin={handleLogin}
                        sendMessage={sendMessage}
                        setShowLanguage={setShowLanguage}                
                    />                
        }
        </FullScreen>
    );
}

export default App;
